/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import * as ReactDOM from 'react-dom/client';
import ReactDOMServer from 'react-dom/server';
import components from './components';

__webpack_nonce__ = document.currentScript?.nonce;

if (!__webpack_nonce__) {
  // eslint-disable-next-line no-console
  console.warn(`⚠️ No nonce provided to webpack.`);
}

const tryHydrateReactComponents = () => {
  // Initialise React if there are any React components.
  if (!document.querySelector('react-component')) {
    return;
  }

  window.React = React;
  (window as any).ReactDOM = ReactDOM;
  window.ReactDOMServer = ReactDOMServer;
  (global as any).Components = components;

  if (
    'ReactJsAsyncInit' in window &&
    typeof window.ReactJsAsyncInit === 'function'
  ) {
    window.ReactJsAsyncInit();
  }
};

tryHydrateReactComponents();
